import styled from 'foundations-theming-specialty/utils';
import { DownIcon } from 'foundations-assets/icons/components/DownIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const Chevron = styled.span.withConfig({
  displayName: "NavChevron__Chevron"
})(({
  $open
}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  transition: 'transform 150ms',
  transform: $open ? 'rotate(180deg)' : 'rotate(0deg)'
}));
export function NavChevron({
  open
}) {
  return /*#__PURE__*/_jsx(Chevron, {
    $open: open,
    children: /*#__PURE__*/_jsx(DownIcon, {
      size: "100"
    })
  });
}